import React from 'react';
import '../App.css';

const DashboardScreen = () => {
  return (
    <div className="app-container">
      <h1>Dashboard</h1>
      <p>Welcome to the Dashboard. This is a placeholder screen.</p>
    </div>
  );
};

export default DashboardScreen;